module.exports = __webpack_public_path__ + "static/bike_rental_cover-868185fb4e394cde2538385c8140c7b6.png";